import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { TeamMembersSelector } from './TeamMembersSelector';

export const TeamMembersSelectorFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'TeamMembersSelector',
    component: TeamMembersSelector,
  }),
);
